var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEmpty = function SvgEmpty(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 213,
    height: 97,
    viewBox: "0 0 213 97",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_667_96031)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 162.387,
    y: 31,
    width: 97,
    height: 35,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.387,
    y: 31,
    width: 97,
    height: 35,
    stroke: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.387,
    y: -4,
    width: 97,
    height: 35,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.387,
    y: -4,
    width: 97,
    height: 35,
    stroke: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.387,
    y: 66,
    width: 97,
    height: 35,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.387,
    y: 66,
    width: 97,
    height: 35,
    stroke: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -44.6133,
    y: 31,
    width: 97,
    height: 35,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -44.6133,
    y: 31,
    width: 97,
    height: 35,
    stroke: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -44.6133,
    y: -4,
    width: 97,
    height: 35,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -44.6133,
    y: -4,
    width: 97,
    height: 35,
    stroke: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -44.6133,
    y: 66,
    width: 97,
    height: 35,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -44.6133,
    y: 66,
    width: 97,
    height: 35,
    stroke: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.3867,
    y: -4,
    width: 112,
    height: 35,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.3867,
    y: -4,
    width: 112,
    height: 35,
    stroke: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.3867,
    y: 66,
    width: 112,
    height: 35,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.3867,
    y: 66,
    width: 112,
    height: 35,
    stroke: "#E7E9EE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.3867,
    y: 31,
    width: 112,
    height: 35,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 163.887,
    cy: 66.5,
    r: 4.5,
    fill: "#1DBADF",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.3867,
    y: 31,
    width: 112,
    height: 35,
    stroke: "#1DBADF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.006 58.4532L108.664 53.5611C108.046 53.2943 107.386 53.8415 107.506 54.5225L109.699 67.0081C109.813 67.6596 110.561 67.9478 111.061 67.5329L114.19 64.936L119.76 72.0881C120.129 72.5621 120.801 72.6375 121.26 72.2562L122.488 71.2367C122.948 70.8557 123.021 70.1625 122.651 69.6884L117.081 62.5363L120.21 59.9394C120.71 59.5245 120.598 58.7087 120.006 58.4532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.006 58.4532L108.664 53.5611C108.046 53.2943 107.386 53.8415 107.506 54.5225L109.699 67.0081C109.813 67.6596 110.561 67.9478 111.061 67.5329L114.19 64.936L119.76 72.0881C120.129 72.5621 120.801 72.6375 121.26 72.2562L122.488 71.2367C122.948 70.8557 123.021 70.1625 122.651 69.6884L117.081 62.5363L120.21 59.9394C120.71 59.5245 120.598 58.7087 120.006 58.4532Z",
    fill: "#4A4A49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9778 50.034C100.413 50.7396 101.848 51.4452 103.283 52.1502C103.917 52.462 104.504 51.4953 103.861 51.1791C102.426 50.4735 100.991 49.7679 99.5558 49.0629C98.922 48.7517 98.3349 49.7184 98.9778 50.034Z",
    fill: "#4A4A49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2058 59.7009C100.69 59.113 102.174 58.525 103.658 57.9371C104.321 57.6748 103.802 56.6674 103.147 56.9272C101.663 57.5151 100.179 58.103 98.6946 58.691C98.0316 58.9533 98.5502 59.9601 99.2058 59.7009Z",
    fill: "#4A4A49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.765 44.1753C106.155 45.7663 106.545 47.3572 106.935 48.9475C107.109 49.6588 108.186 49.4083 108.012 48.6971C107.622 47.1061 107.232 45.5152 106.842 43.9249C106.668 43.213 105.591 43.4634 105.765 44.1753Z",
    fill: "#4A4A49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.419 45.6534C113.507 46.9977 112.596 48.3419 111.684 49.6862C111.277 50.2866 112.218 50.8827 112.625 50.2828C113.536 48.9386 114.448 47.5943 115.359 46.2501C115.766 45.6503 114.826 45.0536 114.419 45.6534Z",
    fill: "#4A4A49"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 212,
    height: 96,
    transform: "translate(0.886719 0.5)",
    fill: "url(#paint0_radial_667_96031)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_667_96031",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(106 48) rotate(90) scale(48 106)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.732292,
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_667_96031"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 212,
    height: 96,
    fill: "white",
    transform: "translate(0.886719 0.5)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmpty, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/empty.71b1c906.svg";
export { ForwardRef as ReactComponent };